import { render, staticRenderFns } from "./feedback_dialog.vue?vue&type=template&id=a959c5de&scoped=true"
import script from "./feedback_dialog.vue?vue&type=script&lang=js"
export * from "./feedback_dialog.vue?vue&type=script&lang=js"
import style0 from "./feedback_dialog.vue?vue&type=style&index=0&id=a959c5de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a959c5de",
  null
  
)

export default component.exports